import {
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  CLEAR_PROFILE_MESSAGES
} from '../constants/profileConstants';

const initialState = {
  loading: false,
  error: null,
  success: false,
  user: null,
  profileData: null,
  loading2: false
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };

    case EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        user: action.payload,
        error: null
      };

    case EDIT_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    case CLEAR_PROFILE_MESSAGES:
      return {
        ...state,
        error: null,
        success: false
      };

    case 'GET_ADMIN_PROFILE_REQUEST':
      return {
        ...state,
        loading2: true,
        error: null
      };

    case 'GET_ADMIN_PROFILE_SUCCESS':
      return {
        ...state,
        loading2: false,
        profileData: action.payload,
        error: null
      };

    case 'GET_ADMIN_PROFILE_FAILURE':
      return {
        ...state,
        loading2: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default profileReducer;